import {BrowserCacheLocation, PublicClientApplication} from '@azure/msal-browser'
import type { Configuration } from '@azure/msal-browser'

const authority = import.meta.env.VITE_OIDC_AUTHORITY || import.meta.env.VITE_OICD_AUTHORITY;
const clientId = import.meta.env.VITE_OIDC_CLIENTID || import.meta.env.VITE_OICD_CLIENTID;

const { protocol, host } = window.location;
const appRootUrl = `${protocol}//${host}${import.meta.env.BASE_URL}auth/signinwin/main`;

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: authority,
    redirectUri: appRootUrl,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
  },
}

export const msalInstance = new PublicClientApplication(msalConfig)

export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email', 'user.read'],
}

export const tokenRequest = {
  scopes: [`api://${clientId}/access_as_user`],
};
